import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/workspaces/{id}/usage — plan usage + feature flags. */
export function useWorkspaceUsage(workspaceId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.workspaceUsage(workspaceId),
    queryFn: ({ signal }) => apiGet(`/workspaces/${workspaceId}/usage`, signal),
    enabled: !!workspaceId && (enabled ?? true),
    ...rest,
  });
}
